import { render } from "./referee_decisions_section.vue?vue&type=template&id=21c52db1"
import script from "./referee_decisions_section.vue?vue&type=script&lang=js"
export * from "./referee_decisions_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__